<template>
  <v-dialog
    v-if="item"
    v-model="visible"
    :fullscreen="mobileScreen"
    max-width="700px"
  >
    <v-card>
      <v-card-title class="card-title">
        <v-layout wrap>
          <v-flex xs10>
            <h2 class="text-xs-left display-3 sz_grafit--text ma-0 mt-1">
              {{ $t('message.move_family') }}
            </h2>
          </v-flex>
          <v-flex xs2>
            <v-layout
              xs12
              justify-end
              align-center
            >
              <v-icon
                large
                class="clickable"
                @click="closeDialog()"
              >
                clear
              </v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout
          row
          wrap
        >
          <v-flex
            sm10
            xs12
            offset-sm2
            offset-xs0
          >
            <v-flex xs12>
              <p class="mb-0">
                {{ fullName(item) }}
              </p>
              <p class="mb-0">
                {{ fullStreet(item) }}
              </p>
              <p class="mb-0">
                {{ fullCity(item) }}
              </p>
              <p class="mt-2 mb-3">
                <span class="fw-600">{{ $t('label.area') }}:</span>
                {{ item.location_name }}
              </p>
            </v-flex>
          </v-flex>
          <v-flex
            sm10
            xs12
            offset-sm2
            offset-xs0
            class="mt-0 pt-0"
          >
            <v-flex
              sm10
              xs12
            >
              <p class="mt-1 mb-0 pb-0 display-1">
                {{ $t('message.to_area') }}:
              </p>
              <v-autocomplete
                v-if="getAvailableWioStructs.length > 0"
                v-model="selectedProvince"
                class="mt-2"
                :data-vv-as="$t('label.province')"
                :items="getAvailableWioStructs"
                item-value="province.province_id"
                :label="$t('label.province')"
                append-icon="expand_more"
                :disabled="getAvailableWioStructs.length === 1"
                item-text="province.name"
              />
              <v-autocomplete
                v-if="getAvailableWioStructs.length > 0"
                v-model="selectedWio"
                class="mt-2"
                :data-vv-as="$t('label.area')"
                :items="currentProvinceWioStructs"
                item-value="id"
                item-text="name"
                :label="$t('label.area')"
                append-icon="expand_more"
                :disabled="currentProvinceWioStructs.length === 0"
              />
            </v-flex>
          </v-flex>
          <v-flex class="ma-1">
            <v-divider />
          </v-flex>
          <v-flex
            sm10
            xs12
            offset-sm2
            offset-xs0
          >
            <v-flex
              sm10
              xs12
            >
              <p
                v-if="item.secondary_volunteer != null"
                class="mb-0 mt-3"
              >
                {{
                  $t('message.manage_region_info', { fullName: item.secondary_volunteer.full_name })
                }}
              </p>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout
          align-center
          class="my-2"
          :column="$vuetify.breakpoint.xsOnly"
          :justify-space-between="$vuetify.breakpoint.smAndUp"
        >
          <v-flex
            order-xs2
            order-sm1
            class="lh-1 none-growth"
            :class="[mobileScreen ? 'mt-2' : 'mr-4']"
          >
            <v-btn
              flat
              class="text-none"
              color="sz_violet"
              @click="closeDialog()"
            >
              <v-icon>chevron_left</v-icon>
              {{ returnText }}
            </v-btn>
          </v-flex>
          <v-flex
            order-xs1
            order-sm2
            class="none-growth"
          >
            <v-btn
              :disabled="selectedWio == null || assignLoader === true"
              :loading="assignLoader"
              color="sz_violet"
              @click="save()"
            >
              {{ $t('buttons.save') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import filters from '@/constants/filters';
import { mapGetters } from 'vuex';

export default {
    name: 'ManageRegionDialog',
    filters: {
        ...filters
    },
    props: ['show', 'item'],
    data () {
        return {
            visible: false,
            selectedProvince: null,
            selectedWio: null,
            assignLoader: false
        };
    },
    watch: {
        show (val) {
            this.visible = val;
        },
        visible (val) {
            this.$emit('show', val);
            if (val === true && !this.isFamilyCard) {
                this.$store
                    .dispatch('family/getFamily', {
                        id: this.item.family_edition_id,
                        endpointLabel: 'family'
                    })
                    .then(() => {
                        const locationName = this.$store.getters['family/getFamily'].location_name;
                        this.$set(this.item, 'location_name', locationName);
                        this.$store.commit('family/setFamily', null);
                    });
            } else if (val === false && !this.isFamilyCard) {
                this.$set(this.item, 'location_name', '');
            }
            if (val === false) {
                if (this.getAvailableWioStructs.length !== 1) {
                    this.selectedProvince = null;
                }
                this.selectedWio = null;
            }
        },
        selectedProvince () {
            this.selectedWio = null;
        },
        getAvailableWioStructs: {
            immediate: true,
            handler (val) {
                if (val.length === 1) {
                    this.selectedProvince = val[0].province.province_id;
                }
            }
        }
    },
    computed: {
        mobileScreen () {
            return this.$vuetify.breakpoint.xs;
        },
        ...mapGetters('defaultApi', ['getAvailableWioStructs']),
        currentProvinceWioStructs () {
            const wio = this.getAvailableWioStructs.find((el) => {
                return el.province.province_id === this.selectedProvince;
            });
            if (wio != null) {
                return wio.wio_structs;
            }
            return [];
        },
        isFamilyCard () {
            return this.$route.name.includes('family-card');
        },
        returnText () {
            if (this.isFamilyCard) {
                return this.$t('buttons.return_to_family_card');
            }
            return this.$t('buttons.return_to_families_list');
        }
    },
    created () {
        this.$store.dispatch('defaultApi/getAvailableWioStructs');
        this.visible = this.show;
    },
    methods: {
        closeDialog () {
            this.visible = false;
        },
        fullName (item) {
            const _firstName = item.first_name !== null ? item.first_name : '';
            return _firstName + ' ' + item.last_name;
        },
        fullStreet (item) {
            const street = item.street ? item.street : '';
            const _flat = item.flat_number !== null ? '/' + item.flat_number : '';
            return street + ' ' + item.building_number + _flat;
        },
        fullCity (item) {
            return this.$options.filters.postalCode(item.postal_code) + ' ' + item.city;
        },
        save () {
            this.assign();
        },
        assign () {
            this.assignLoader = true;
            this.$store
                .dispatch('family/changeRegion', {
                    familyEditionId: this.item.family_edition_id,
                    wioId: this.selectedWio
                })
                .then(({ data }) => {
                    this.$store.commit('family/setFamily', data.data);
                })
                .finally(() => {
                    this.assignLoader = false;
                    this.closeDialog();
                });
        }
    }
};
</script>

<style lang="scss" scoped></style>
